import { format } from '../../../internal/utils/date';
export function formatDateValueToHTML(value) {
  if (value instanceof Date) {
    return format('HH:mm', value);
  }
  if (typeof value === 'string') {
    return value;
  }
  return '00:00';
}